module.exports = __webpack_public_path__ + "img/la-tomatina-2012-2.30b1676f.jpg";